import { createContext } from 'react';

export const HoneycombShowLabelsContext = createContext(false);
